import axios from "axios";
import { RubiqConsentText } from "../Models/ConsentModel";
import { APIUrl } from "../constants";

let consentText: RubiqConsentText | null = null;
let consentGiven: boolean = false;

const getConsentApiUrl = () => {
    return `${APIUrl}/api/Consent/GetConsentText`;
};

const getConsentExistUrl = ()=> {
    return `${APIUrl}/api/Consent/HasConsent`;
}

export const getConsentText = () => {
    if (consentText !== null) {
        return consentText;
    } else {
        // Backup solution if API not responding?
        return new RubiqConsentText(false, {
            footer: `Du kan altid ændre eller trække dit samtykke tilbage, bl.a. <a href="https://afmeld.norlys.dk" target="_blank">her</a>.<br>
                    <br>
                    Markedsføringen tilpasses på baggrund af mine kundeoplysninger og brugeradfærd, herunder købs-, forbrugs- og betalingshistorik, forsyningstilgængelighed, surveybesvarelser, kontakthistorik og webadfærd. Oplysningerne kan også anvendes til markedsføring på sociale medier** og på Google, til profilering og til brug for udvikling og test af vores it-systemer, herunder AI-løsninger. Du kan læse mere om, hvordan vi behandler dine personoplysninger i vores <a href="https://norlys.dk/persondatapolitik-norlys" target="_blank">privatlivspolitik</a>, hvor du også kan læse om, hvordan du gør indsigelse, hvis du ikke ønsker, at vi bruger oplysningerne til de nævnte formål.<br>
                    <br>
                    *Internet, underholdningstjenester, mobil og telefoni, elektronisk udstyr, energi, opladning, intelligent styring og tilbehør samt services indenfor de nævnte produktkategorier.<br>
                    **Facebook, Instagram og LinkedIn.`,
            marketing: `Ja tak, Norlys Energi A/S, Norlys Digital A/S og Norlys Mobil A/S (inkl. Call me) må gerne kontakte mig via e-mail, sms og telefon på vegne af dem selv og hinanden med markedsføring om selskabernes produkter*, konkurrencer, events og branding.`,
            marketingHeader: `Markedsføringssamtykke`,
            prefCenterFooter: `Markedsføringen tilpasses på baggrund af mine kundeoplysninger og brugeradfærd, herunder købs-, forbrugs- og betalingshistorik, forsyningstilgængelighed, surveybesvarelser, kontakthistorik og webadfærd. Oplysningerne kan også anvendes til markedsføring på sociale medier** og på Google, til profilering og til brug for udvikling og test af vores it-systemer, herunder AI-løsninger. Du kan læse mere om, hvordan vi behandler dine personoplysninger i vores <a href="https://norlys.dk/persondatapolitik-norlys" target="_blank">privatlivspolitik</a>, hvor du også kan læse om, hvordan du gør indsigelse, hvis du ikke ønsker, at vi bruger oplysningerne til de nævnte formål.<br>
                                <br>
                                *Internet, underholdningstjenester, mobil og telefoni, elektronisk udstyr, energi, opladning, intelligent styring og tilbehør samt services indenfor de nævnte produktkategorier.<br>
                                **Facebook, Instagram og LinkedIn.`,
            tracking: `Når selskaberne sender mig e-mails, må de bruge pixels, så de kan analysere om og hvorfra jeg har åbnet e-mailen, samt hvilke links jeg har klikket på, for at tilpasse fremtidig markedsføring.`,
            trackingHeader: `Må Norlys indsamle data om min interaktion via pixels?`
        });
    }
}

export const fetchConsentText = async () => {
    try {
        let result = await axios.get(getConsentApiUrl());
        if (result.status === 200) {
            consentText = result.data as RubiqConsentText;
            return consentText;
        }
        return getConsentText();
    } catch (error) {
        return getConsentText();
    }
};

export const checkConsent = async (phone:string, email:string)=>{
 try {
        let result = await axios.post(getConsentExistUrl(), {phone, email});
        if (result.status === 200) {
            consentGiven = result.data as boolean;
        }
        
    } catch (error) {
        consentGiven = false;
    }
};

export const hasConsent = ()=> {
    return consentGiven;
}